import { Route, Routes, useLocation } from "react-router-dom"
import { useLayoutEffect, useRef } from "react"
import { Footer, Header } from "./layouts"
import Main from "./Main"
import Location from "./pages/location/Location"
import Auth from "./pages/auth/Auth"
import Buy from "./pages/buy/Buy"
import NotificationsModal from "./pages/profile/screens/NotificationsModal"
import { AppInitializer } from "./AppInitializer"
import { ErrorToast } from "../components/ErrorToast"
import ErrorBoundary from "../components/ErrorBoundary"
import UnpaidTicketNotice from "../components/UnpaidTicketNotice"
import CookieNotice from "../components/CookieNotice"
import SeoJsonLd from "../components/SeoJsonLd"
import { usePageSeo } from "../hooks/usePageSeo"

type ModalRouteState = { backgroundLocation?: { pathname: string } } | null

function ScrollToTop() {
    const { pathname, hash, state } = useLocation()
    const isModalRoute = Boolean((state as ModalRouteState)?.backgroundLocation)
    const prevRef = useRef<{ pathname: string; state: ModalRouteState } | null>(null)
    useLayoutEffect(() => {
        const prev = prevRef.current
        prevRef.current = { pathname, state: state as ModalRouteState }
        /* Модалка поверх фона — фоновую страницу не скроллим */
        if (isModalRoute) return
        /* Возврат из модалки на её фоновую страницу — позиция прокрутки сохраняется */
        if (prev?.state?.backgroundLocation?.pathname === pathname) return
        if (hash) {
            const target = document.getElementById(hash.slice(1))
            if (target) {
                target.scrollIntoView({ block: "start" })
                return
            }
        }
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
    }, [pathname, hash])
    return null
}

const App = () => {
    const location = useLocation()
    const state = location.state as { backgroundLocation?: Location }
    const background = state?.backgroundLocation || location
    usePageSeo()

    return (
        <ErrorBoundary>
            <div
                className="flex min-h-[100svh] md:min-h-screen flex-col"
                style={{ fontFamily: "'Manrope', sans-serif" }}>
                <SeoJsonLd />
                <ScrollToTop />
                <ErrorToast />
                <Header />
                <Main location={background} />
                {state?.backgroundLocation && (
                    <Routes>
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/location" element={<Location />} />
                        <Route path="/buy" element={<Buy />} />
                        <Route path="/profile/notifications" element={<NotificationsModal />} />
                    </Routes>
                )}
                <Footer />
                <UnpaidTicketNotice />
                <CookieNotice />
                <AppInitializer />
            </div>
        </ErrorBoundary>
    )
}

export default App
